import api from '@/services/utils/base';
import store from '@/store';

export default class TrafficSource {
  postCreate(payload: any) {
    return api.post('traffic-sources', payload).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
    .catch((err: any) => {
      return Promise.reject(err);
    });
  }

  get(id: string) {
    return api.get(`traffic-sources/${id}`).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
  }

  getList(params?:any) {
    const newParams = {...params}
    delete newParams.workspaceId;
    return api.get('traffic-sources',{ 
        params:{
        ...newParams,
        workspaceIds:[...new Set([params.workspaceId,...store.getters.allPublicWorkspacesIds])]
      }
    }).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
    .catch((err: any) => {
      return Promise.reject(err);
    });
  }

  putUpdate(id: string, payload: any) {
    return api.put(`traffic-sources/${id}`, payload);
  }

  delete(id: string) {
    return api.delete(`traffic-sources/${id}`);
  }

  postArchive(payload: any) {
    return api.post('traffic-sources/archive', payload);
  }

  postRestore(payload: any) {
    return api.post('traffic-sources/restore', payload);
  }

  postDuplicate(payload: any) {
    return api.post('traffic-sources/duplicate', payload);
  }

  getTemplates(){
    return api.get('traffic-sources-templates').then((res: any) => {
      return Promise.resolve(res.data.payload);
    });
  }

  getCount(payload: object) {
    return api.get('traffic-sources/count', payload);
  }

  updateStoreCache({workspaceId}) {
    return api.get('traffic-sources', {
      params:{
        status:'active',
        limit:'200',
        orderBy:'updated',
        orderDirection:'desc',
        columns:['name','id','workspaceId'],
        workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])]
      }
    }).then((res)=>{
      store.commit('updateTrafficSourcesCache', {
        workspaceId,
        data:res.data.payload
      });
      return Promise.resolve(res.data.payload);
    })
  }

  populateStoreCache() {
    return api.get('traffic-sources', {
      params:{
        status:'active',
        limit:'200',
        orderBy:'updated',
        orderDirection:'desc',
        columns:['name','id','workspaceId']
      }
    }).then((res)=>{
      store.commit('populateTrafficSourcesCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
}
